import React from 'react';

import { token } from '@atlaskit/tokens';
import ProgressBar from '@atlaskit/progress-bar/progress-bar';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Flex } from '@atlaskit/primitives/compiled/flex';
import { cssMap } from '@atlaskit/css';

import type { Doc } from '../../../hooks/useUploadReducer.ts';
import { ErrorRoles } from '../../../hooks/useUploadReducer.ts';

import { ProgressStatus } from './progress-types.ts';
import { ErrorMessage } from './ErrorMessage.tsx';

const styles = cssMap({
	container: {
		marginBottom: token('space.300'),
	},
	error: {
		marginBottom: 0,
	},
	barName: {
		textOverflow: 'ellipsis',
		overflow: 'hidden',
		width: '260px',
		whiteSpace: 'nowrap',
	},
	progressText: {
		minWidth: '40px',
		color: token('color.text'),
	},
	progressContent: {
		flexBasis: '100%',
	},
});

type ProgressBarItemProps = {
	progress: number;
	doc?: Doc;
	status?: string;
	children?: React.ReactNode;
	testId?: string;
};

export const ProgressBarItem: React.FC<ProgressBarItemProps> = ({
	progress,
	doc,
	children,
	status,
	testId,
}) => {
	return (
		<Box xcss={styles.container} testId={testId}>
			<Flex>
				<Box xcss={styles.progressContent}>
					<Flex justifyContent="space-between">
						<Box xcss={styles.barName}>{doc?.nameWithoutExt}</Box>
						<Box as="span" xcss={styles.progressText}>
							{doc &&
								doc?.error?.role !== ErrorRoles.ERROR &&
								status !== ProgressStatus.ERROR &&
								`${progress}%`}
						</Box>
					</Flex>
					<ProgressBar
						ariaLabel="upload progress bar"
						value={doc?.completed || status === ProgressStatus.ERROR ? 1 : progress / 100}
					/>
				</Box>
				{children}
			</Flex>
			{doc?.error && (
				<Box xcss={styles.error}>
					<ErrorMessage doc={doc} />
				</Box>
			)}
		</Box>
	);
};
